export const popover = {
  root: ({ attrs }: Record<string, any>) => ({
    class: [
      'translate-y-px',
      'rounded',
      {
        'text-white bg-primary-700 shadow-lg': attrs.theme === 'dark',
        'text-black bg-white shadow-sm': attrs.theme === 'primary',
      },
    ],
    role: attrs.role,
  }),
  content: ({ attrs }: Record<string, any>) => ({
    class: [
      'items-center flex',
      'rounded',
      {
        'border border-grey-200': attrs.theme === 'primary',
      },
    ],
  }),
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
